import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=6bf3fc8f&scoped=true&"
import script from "./updateDialog.vue?vue&type=script&lang=js&"
export * from "./updateDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=6bf3fc8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3fc8f",
  null
  
)

export default component.exports